import { createFileRoute } from '@tanstack/react-router'
import FinanceiroSistemaPage from '@/pages/dashboard/financeiro-sistema-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/financeiro',
)({
  component: function FinanceiroSistemaRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.FINANCEIRO} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.FINANCE_FULL}>
          <FinanceiroSistemaPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
